module.exports = __webpack_public_path__ + "assets-cabinet/img/a_eur--sign.eaa68cda.svg";